import { A11yModule } from '@angular/cdk/a11y';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PhxTooltipDirective } from './phx-tooltip.directive';
import { PhxTooltipComponent } from './phx-tooltip.component';
import { PhxIconModule } from './../icon/icon.module';
import { PhxTooltipOnTruncateDirective } from './phx-tooltip-on-truncate.directive';

@NgModule({
  declarations: [
    PhxTooltipComponent,
    PhxTooltipDirective,
    PhxTooltipOnTruncateDirective,
  ],
  entryComponents: [
    PhxTooltipComponent
  ],
  exports: [
    PhxTooltipComponent,
    PhxTooltipDirective,
    PhxTooltipOnTruncateDirective,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    PhxIconModule,
    A11yModule,
  ],
})
export class PhxTooltipModule { }
